(function () {
  const SECTION_SELECTOR = '.it-hero-section';
  const FADE_SELECTOR = '.hero-fade';
  // Kept short so the hero (the LCP element) paints quickly. A long delay here
  // hides the H1 behind opacity:0 and pushes LCP/Speed Index way up.
  const HERO_ANIMATION_DELAY = 200;
  const TYPE_SPEED = 105;
  const DELETE_SPEED = 70;
  const WORD_PAUSE = 1700;
  const LOOP_PAUSE = 420;
  const WORDS = ['WORKS', 'CONVERTS', 'SELLS', 'SCALES'];

  function animateFade(section) {
    const fadeElements = section.querySelectorAll(FADE_SELECTOR);

    section.classList.add('is-animated-ready');

    fadeElements.forEach((element, index) => {
      window.setTimeout(() => {
        element.classList.add('is-animated-in');
      }, HERO_ANIMATION_DELAY + (index * 120));
    });
  }

  function animateTypedWord(section) {
    const title = section.querySelector('.it-hero-section__title');

    if (!title) {
      return;
    }

    const wordElement = title.querySelector('span');

    if (!wordElement) {
      return;
    }

    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function tick() {
      const currentWord = WORDS[wordIndex];

      if (!isDeleting) {
        charIndex += 1;
        wordElement.innerHTML = currentWord.slice(0, charIndex) + '<span class="typewriter-cursor"></span>';

        if (charIndex === currentWord.length) {
          isDeleting = true;
          window.setTimeout(tick, WORD_PAUSE);
          return;
        }

        window.setTimeout(tick, TYPE_SPEED);
        return;
      }

      charIndex -= 1;
      wordElement.innerHTML = currentWord.slice(0, charIndex) + '<span class="typewriter-cursor"></span>';

      if (charIndex === 0) {
        isDeleting = false;
        wordIndex = (wordIndex + 1) % WORDS.length;
        window.setTimeout(tick, LOOP_PAUSE);
        return;
      }

      window.setTimeout(tick, DELETE_SPEED);
    }

    window.setTimeout(tick, HERO_ANIMATION_DELAY + 180);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      animateFade(section);
      animateTypedWord(section);
    });
  });
})();
